import './QuantityStepper.css';

interface QuantityStepperProps {
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
}

export default function QuantityStepper({ quantity, onIncrement, onDecrement }: QuantityStepperProps) {
  return (
    <div className="quantity-stepper">
      <button
        className="quantity-stepper__button"
        aria-label="Decrease quantity"
        onClick={(e) => {
          e.stopPropagation();
          onDecrement();
        }}
      >
        −
      </button>
      <span className="quantity-stepper__count" aria-live="polite">
        {quantity}
      </span>
      <button
        className="quantity-stepper__button"
        aria-label="Increase quantity"
        onClick={(e) => {
          e.stopPropagation();
          onIncrement();
        }}
      >
        +
      </button>
    </div>
  );
}
